import { useMemo } from 'react';
import { pipe } from 'fp-ts/function';
import { array } from 'fp-ts';
import { CorrectionType } from '@mews-commander/data-access';
import { useCompanyClosedBills } from '../../../../queries';

const ignoredCorrectionTypes = [
    CorrectionType.CreditNote,
    CorrectionType.ReceivablePaymentsBalance,
    CorrectionType.Reinstatement,
];

export const useDashboardBills = (...params: Parameters<typeof useCompanyClosedBills>) => {
    const { data, refetch, isLoading } = useCompanyClosedBills(...params);

    const { left: bills, right: corrections } = useMemo(() => {
        if (!data) {
            return { left: undefined, right: undefined };
        }

        return pipe(
            data,
            array.partition(
                ({ correctionType }) => !!correctionType && !ignoredCorrectionTypes.includes(correctionType)
            )
        );
    }, [data]);

    return { bills, corrections, refetch, isLoading };
};
